import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modules: {
    cdp: true,
    marketing: true,
    fidelite: true,
  },
  canaux: {
    sms: true,
    email: true,
  },
};

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    updateModuleAccess: (state, action) => {
      const { module, value } = action.payload;
      state.modules[module] = value;
    },
    updateCanalAccess: (state, action) => {
      const { canal, value } = action.payload;
      state.canaux[canal] = value;
    },
  },
});

export const { updateModuleAccess, updateCanalAccess } = preferencesSlice.actions;

// Sélecteurs
export const selectModuleAccess = (state, module) => state.preferences.modules[module];
export const selectCanalAccess = (state, canal) => state.preferences.canaux[canal];

export default preferencesSlice.reducer;
